// extracted by mini-css-extract-plugin
export default {"loader":"controls_loader__2Cf06","spin":"controls_spin__jRVAY"};